export default __webpack_public_path__ + "static/media/discount-applying-img.f4e1d5c5.png";